import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { IoniconsOutline } from '@pt/pt-models';
import { DpiaColumn } from 'it/primatoo/openapi/api/org/schemas/dpia/dpiaevaluation/DpiaColumn';
import { DpiaEvalRow } from 'it/primatoo/openapi/api/org/schemas/dpia/dpiaevaluation/DpiaEvalRow';

/**
 * ATTENZIONE: questo componente è usato anche all'interno dell'editor della DPIA,
 * Li il suo funzionamento è corretto, se utilizzato altrove o clonarlo o evitare di modificare il comportamento nell'editor
 * nota di @giovanni
 */
@Component({
  selector: 'pt-dpia-stats-editor',
  template: `
    <div class="pb-2">
      <pt-details-title
        class="display-contents"
        *ngIf="title" [title]="title">
        <ng-container titleExtra>
          <pt-icon
            *ngIf="showReloadButton"
            [size]="18"
            container='body'
            [key]="iconReload"
            class="ms-2 dc-recalculate-button"
            ngbTooltip="{{'BUTTON.RECALCULATE' | translate}}"
            (click)="reload.emit()"
          ></pt-icon>
        </ng-container>
      </pt-details-title>
    </div>

    <ng-template
      *ngIf='rows?.length > 0 && columns?.length > 0; then statsAvailable; else noStatsAvailable'
    ></ng-template>

    <ng-template #statsAvailable>
      <div [ngClass]='containerCssClass'>

        <ng-template
          *ngIf="mode === 'DIALOG'; then DIALOG; else TABLE"></ng-template>

        <ng-template #DIALOG>
          <button class='btn btn-sm btn-success w-100' (click)='open(content)'>
<!--            <span>{{ 'MESSAGE.AVAILABLE_STATS' | translate }}</span>-->
            Calcolo Rischi
          </button>
        </ng-template>

        <ng-template #TABLE>
          <div [ngClass]='tableCssClass'>
            <pt-dpia-stats-table
              [threatLabel]='"LABELS.THREATS" | translate'
              [demageLabel]='"LABELS.DEMAGES" | translate'
              [typeLabel]='"LABELS.TYPE" | translate'
              [columns]='columns'
              [fixColWidth]='true'
              [rows]='rows'>
            </pt-dpia-stats-table>
          </div>
        </ng-template>

      </div>
    </ng-template>

    <ng-template #noStatsAvailable>
      <pt-no-available-stats>
        <pt-icon
          *ngIf="showReloadButton"
          [size]="18"
          container='body'
          [key]="iconReload"
          class="ms-2 dc-recalculate-button"
          ngbTooltip="{{'BUTTON.RECALCULATE' | translate}}"
          (click)="reload.emit()"
        ></pt-icon>
      </pt-no-available-stats>
    </ng-template>

    <ng-template #content>
      <div class='modal-header'>
        <h4 class='modal-title' id='modal-basic-title'>
          {{'LABELS.DPIA_RESULTS' | translate}}
        </h4>
        <button type='button' class='btn-close' aria-label='Close' (click)='closeDialog()'>
        </button>
      </div>

      <div class='modal-body modal-body-overflow-y'>
        <pt-dpia-stats-table
          [threatLabel]='"LABELS.THREATS" | translate'
          [demageLabel]='"LABELS.DEMAGES" | translate'
          [typeLabel]='"LABELS.TYPE" | translate'
          [columns]='columns'
          [rows]='rows'
          [fixColWidth]='true'>
        </pt-dpia-stats-table>
      </div>
    </ng-template>
  `,
  styles: [`
    .modal-body-overflow-y {
      max-height: 550px;
      overflow-y: auto;
    }

    .dc-recalculate-button {
      display: flex;
      cursor: pointer;
      color: #000000;
    }

    .dc-recalculate-button:hover {
      color: #737373;
    }
  `],
  providers: [NgbModalConfig, NgbModal]
})
export class DpiaStatsEditorComponent implements OnDestroy {
  @Input() title: string;
  @Input() showReloadButton: boolean;
  @Input() mode: 'DIALOG' | 'TABLE' = 'TABLE';
  @Input() tableCssClass: string;
  @Input() containerCssClass: string;
  @Input() columns: DpiaColumn[];
  @Input() rows: DpiaEvalRow[];
  @Output() reload = new EventEmitter<boolean>();
  iconReload = IoniconsOutline.reload;
  private currentDialog;

  constructor(config: NgbModalConfig, private modalService: NgbModal) {
    config.backdrop = true; // 'static';
    config.keyboard = false;
    config.centered = true;
    config.size = 'xl';
  }

  open(content) {
    this.reload.emit();
    this.currentDialog = this.modalService.open(content);
  }

  ngOnDestroy(): void {
    this.closeDialog();
  }

  closeDialog() {
    if (this.currentDialog) {
      this.currentDialog.close();
    }
  }
}
